import axios from "axios";
import { ElMessage, ElLoading } from "element-plus";

// 创建 Axios 实例
const service = axios.create({
  baseURL: "https://image.manmcz.com" || "", // 使用环境变量配置 API 基础路径
  timeout: 30000, // 请求超时时间
});

let loadingInstance;

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 检查是否需要显示加载动画
    if (config.showLoading !== false) {
      loadingInstance = ElLoading.service({
        lock: true,
        text: "Loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    }
    // 在发送请求之前做点什么，比如添加 token
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    if (loadingInstance) {
      loadingInstance.close();
    }
    // 处理请求错误
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 处理响应数据
    if (loadingInstance) {
      loadingInstance.close();
    }
    const { data } = response;
    if (data.code !== 1 && data.code !== 100) {
      // 根据业务逻辑处理错误
      ElMessage.error(data.msg || "Error");
      // return Promise.reject(new Error(data.message || "Error"));
    }
    return data;
  },
  (error) => {
    if (loadingInstance) {
      loadingInstance.close();
    }

    // 处理响应错误，比如处理 401 或其他错误
    const { response } = error;
    if (response && response.status === 401) {
      console.error("未授权，请重新登录");
      // 可以在这里触发重定向到登录页面逻辑
    }
    return Promise.reject(error);
  }
);

export default service;
